// See
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#custom_error_types
export default class InputError extends Error {
  constructor(message, fileName, lineNumber, title = "Required field") {
    super(message, fileName, lineNumber);

    if (Error.captureStackTrace) Error.captureStackTrace(this, InputError);

    this.name = "InputError";
    this.title = title;
  }
}
